import { ScreenAction } from "Store/Screen/actions";

export interface IScreen {
  width: number;
}

const initialScreen: IScreen = {
  width: typeof window === 'object' ? window.innerWidth : null,
};

function screen(state: IScreen = initialScreen, action: ScreenAction): IScreen {
  switch (action.type) {
    case 'SCREEN_RESIZE':
    return {
      ...state,
      width: action.width,
    };

    default:
      return state;
  }
}

export default screen;



// WEBPACK FOOTER //
// ./src/store/Screen/reducer.tsx